import Service from './Service';
import {SERVER_URL} from '../utils/Constants';
import GeneralUtils from '../utils/GeneralUtils';

export default class SupplierProductService extends Service {
    constructor() {
        super();
        this.baseURL = 'inventory/supplierProduct';
    }

    findUsages(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/' + id + '/usages', {
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem('merchantBranchId')
            },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
            return [];
        });
    }

    recalculateSelection() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/recalculateSelection', {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem('merchantBranchId')
            },
        }).then(response => {
            const result = response.clone();
            if (response.status === 200) {
                // Async job accepted; avoid generic "success" toast — UI shows started message.
                return GeneralUtils.responseToJson(result);
            }
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    sendFromPurchaseOrders(purchaseOrderIds) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/sendFromPurchaseOrders', {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem('merchantBranchId')
            },
            body: JSON.stringify(purchaseOrderIds)
        }).then(response => {
            const result = response.clone();
            // Caller shows its own success message; only surface errors here.
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}